export const SUPPORTED_LOCALE_VALUES = ["nl-BE", "fr-BE"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALE_VALUES)[number];

export const DEFAULT_LOCALE = "nl-BE" as const satisfies SupportedLocale;

export const SUPPORTED_LANGUAGE_VALUES = ["nl", "fr"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGE_VALUES)[number];

const LANGUAGE_FOR_LOCALE = { "nl-BE": "nl", "fr-BE": "fr" } satisfies Record<SupportedLocale, SupportedLanguage>;

export const languageForLocale = (locale: SupportedLocale) => LANGUAGE_FOR_LOCALE[locale];

/** Flat translation object retrieved with the key `domain-model.${model}.list.search`. */
export interface ListSearchTranslations {
	placeholder?: string;
}

/**
 * Flat translation object retrieved with the key `domain-model.${model}.list.emptyData` or
 * `domain-model.${model}.list.emptySearch` (the `EmptyFeedback` shape).
 */
export interface ListEmptyFeedbackTranslations {
	title?: string;
	message?: string;
}
